import {
  AutoCompleteCountry,
  FormInput,
  ISelectCountry,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";

const translationPath = "chatBot.page.service.blacklist.";

export const BlacklistContact = memo(
  ({ countries }: { countries: ISelectCountry[] }) => {
    const { t } = useTranslation();

    const { control, setValue, getValues } = useFormContext();

    const ddi: ISelectCountry = useWatch({
      control,
      name: "ddi",
    });

    const phoneMask = useMemo(() => ddi?.phoneMask || "", [ddi]);

    const setDdi = useCallback(async () => {
      const phoneNumberValue: string = getValues("phoneNumberValue");

      if (phoneNumberValue) return;
      const brazil = countries.find((c) => c.ddiCode === "55");
      const ddiUpdate = brazil || countries[0];

      setValue("ddi", ddiUpdate);
    }, [setValue, getValues, countries]);

    useEffect(() => {
      setDdi();
    }, [setDdi]);

    return (
      <Grid container spacing={2} sx={{ mb: 2, alignItems: "center" }}>
        <Grid item xs={2} sm={4}>
          <AutoCompleteCountry
            name="ddi"
            label={t(translationPath + "ddi") || "DDI"}
            size="small"
            getOptionLabel={(option) => `${option.code} +${option.ddiCode}`}
            options={countries}
          />
        </Grid>
        <Grid item xs={2} sm={8}>
          <FormInput
            name="phoneNumberValue"
            label={t(translationPath + "contact_number") || "Valor"}
            mask={phoneMask}
            fullWidth
            size="small"
          />
        </Grid>
      </Grid>
    );
  }
);
